(function($, window, undefined) {
function update_quote() {};
function hideSlide() {
$('.wooslider .slides > li').not(":first").css('display', 'none');
$('.wooslider_wrap .loading').fadeOut('450', 'swing');
}
function update() {
update_quote();}
$(window).load(function() {
hideSlide();
$('.loading').fadeOut('350');
$('body').addClass('open');
})
})(jQuery, window);


(function($, window, undefined) {
var $w = $(window),
$imgCovers = $('.img-cover');
function init() {
$('.img-cover').each(function() {
var $cover = $(this),
$img = $cover.find('img');
$cover.css('background-image', 'url(' + $img.attr('src') + ')');
});}



$(document).ready(function() {
$('a.arr').on('click', function(e) {
e.preventDefault();
if ($('.single-post').length) {
$('html,body').animate({ scrollTop :  $w.height() + 'px' }, '300');
} else {
$('html,body').animate({ scrollTop :  ($w.height() - 0 ) + 'px' }, '300');
}
});



$('.full-H').each(function() {
$(this).css({ 'height' : $w.height() });
});

$('.full-xH').each(function() {
$(this).css({ 'height' : ( $w.height()) });
});


init();

})

$(window).on('resize', function(event) {
event.preventDefault();

$('.full-H').each(function() {
$(this).css({ 'height' : $w.height() });
});

$('.full-xH').each(function() {
$(this).css({ 'height' : ( $w.height()) });
});



});

})(jQuery, window);